<template>
  <Form 
    :d_form='form'
    :d_kategori='kategori'
    :d_ternakan='lkp_ternakan'
    :d_jurusan='lkp_jurusan'
    :d_baka='lkp_baka'
    :d_negara='lkp_negara'
    :d_gred='lkp_gred'
    :d_status='lkp_status'
    :d_jantina='jantina'
    :files='files'
    v-if="id > 0 && load == 9"
  /> 
  
  <Form 
    :d_form='form'
    :d_kategori='kategori'
    :d_ternakan='lkp_ternakan'
    :d_jurusan='lkp_jurusan'
    :d_baka='lkp_baka'
    :d_negara='lkp_negara'
    :d_gred='lkp_gred'
    :d_status='lkp_status'
    :d_jantina='jantina'
    :files='files'
    v-else-if="id == 0 && load == 6"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.stpp_katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Katalog Pejantan', route: '/se/katalog' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        ternakan_id : 0,
        kategori : 1,
        lkp_ternakan_id : '',
        lkp_jurusan_id : '',
        lkp_baka_id : '',
        lkp_negara_id : '',
        lkp_gred_id : '',
        kode : '',
        nama : '',
        jantina : 1,
        tarikh_lahir : '',
        attahecment : '',
        hantar:0,
        lkp_status_id : 1,
        
      },
      kategori : 1,
      lkp_ternakan : [],
      lkp_jurusan : [],
      lkp_baka : [],
      lkp_negara : [],
      lkp_gred : [],
      lkp_status : [],
      jantina : [],
      fileCiri2: [],
      files: [],
      attahecment : [],
      load : 0
      
      
    }
  },
  methods: {
    

    

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
        this.load = this.load + 1
      })
    },

    getKategori(){
      this.$zcomm.get(this.api_service + 'lookup/kategori', {}).then(res => {
        this.kategori = res
        this.load = this.load + 1
      })
    },

    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
        this.load = this.load + 1
      })
    },

    getJurusan(i){

      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
        this.load = this.load + 1
      })
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
        this.load = this.load + 1
      })
    },

    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
        this.load = this.load + 1
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status = res
        this.load = this.load + 1
      })
    },

    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
        this.load = this.load + 1
      })
    },

 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_katalog/show/'+this.id, {}).then(res => {
          if(res.lkp_ternakan_id > 0){
            this.getJurusan(res.lkp_ternakan_id)
            this.getBaka(res.lkp_jurusan_id)
          }
          this.form = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    
    this.getKategori()
    this.getNegara()
    this.getTernakan()
    this.getGred()
    this.getStatus()
    this.getJantina()
    this.getData()
    
  }
    
}
</script>
